import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/authContext';
import { routes } from '../routes';
import { Navigate } from 'react-router';
import { Spinner } from 'flowbite-react';

interface ProtectedRouteProps {
    children: React.ReactElement;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
    const { verified, refreshToken, setVerified } = useAuth();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const verifyUser = async () => {
            try {
                if (!verified) {
                    const response = await refreshToken();
                    if (response.length > 0) {
                        setVerified(false);
                        return;
                    }
                }
            } finally {
                setLoading(false);
            }
        };

        verifyUser();
    }, [verified, refreshToken, setVerified]);

    if (loading) {
        return (
            <div className="h-screen flex justify-center items-center">
                <Spinner size="xl" />
            </div>
        );
    }

    if (!verified) {
        return <Navigate to={routes.LOGIN} replace />;
    }

    return children;
};

export default ProtectedRoute;
